import React from 'react';

const LOCALIZATION_HELP_TEXT: string =
  'For numbers, this sets the supported decimal and group delimiters. For ambiguous dates (e.g. 1/2/2023), this sets whether they are “day first” or “month first.”';

const IGNORE_TEXT: string = '(Can be safely ignored if your output files are Excel spreadsheets.)';

interface LocalizationHelpBlockProps {
  includeIgnoreIfExcelText: boolean;
}

export default function LocalizationHelpBlock({
  includeIgnoreIfExcelText,
}: LocalizationHelpBlockProps): JSX.Element {
  return (
    <div>
      {LOCALIZATION_HELP_TEXT} See{' '}
      <a
        href="https://help.benchling.com/hc/en-us/articles/9684264100749-How-can-I-change-my-language-settings-or-date-format-"
        target="_blank"
        rel="noopener noreferrer"
      >
        here
      </a>{' '}
      for a full list of supported date formats. {includeIgnoreIfExcelText && IGNORE_TEXT}
    </div>
  );
}
